import { BaseModel } from "@blue-chip/core";

export default class Location extends BaseModel {}
